import React from 'react';
import { Box } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import ROUTES from '@/common/routes';
import { Access } from '@/modules/core/components';
import Topbar from '@/modules/core/components/Topbar/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks';
import ContributionsList from '@/modules/employer/components/Contributions/ContributionsList/ContributionsList';
import { ScheduledContributionList } from '@/modules/employer/components/Contributions/ScheduledContribution';
import TopSection from '@/modules/employer/components/Contributions/TopSection';
import theme from '@/styles/theme';

import PageScrollVisibleWrapper from './PageScrollVisibleWrapper';

const ContributionsPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.CONTRIBUTIONS,
      title: 'Contributions',
    },
  ]);

  return (
    <Access accessRequirements={[{ permission: Permissions.VIEW_CONTRIBUTIONS }]}>
      <PageScrollVisibleWrapper>
        <Topbar />
        <Box align="center" pad={{ bottom: 'spacing72' }}>
          <Box width={theme.defaultContentWidth}>
            <TopSection />
            <ScheduledContributionList />
            <ContributionsList />
          </Box>
        </Box>
      </PageScrollVisibleWrapper>
    </Access>
  );
};

export default ContributionsPage;
